import { AuthService } from '@anecdotes/auth-core';
import { FeatureFlagsService } from '@anecdotes/feature-flags';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

@Injectable()
export class FeatureFlagGuard  {
  constructor(
    private featureFlagsService: FeatureFlagsService,
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (!await this.authService.isAuthenticatedAsync()) {
      return true;
    }
    
    if (!childRoute.data.featureFlag) {
      return true;
    }
    if (
      !(await this.featureFlagsService.IsEnabledAsync(
        Array.isArray(childRoute.data.featureFlag) ? childRoute.data.featureFlag : [childRoute.data.featureFlag],
        this.getContext(childRoute),
      ))
    ) {
      this.router.navigate(['/no-access'], { skipLocationChange: true });
      return false;
    }

    return true;
  }

  private getContext(childRoute: ActivatedRouteSnapshot): any {
    const result = { ...childRoute.data, ...childRoute.params };

    if (childRoute.parent) {
      return { ...result, ...this.getContext(childRoute.parent) };
    }

    return result;
  }
}
